import { Helmet } from "react-helmet-async"
import { useEffect, useState } from "react"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../../components/ui/carousel"
import { DoctorCard } from "../../components/doctor-card"
import OurDoctorswidget from "../../components/widgets/ourdoctors"
import { Badge } from "../../components/ui/badge"
export default function Leadership() {
 
 
  return (
    <>
      <Helmet>
        <title>Leadership - Pranaam Hospitals</title>
      </Helmet>
     
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
         <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-16 md:py-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <Badge className="mb-4 px-3 py-1">Our Leadership</Badge>
              <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                Meet Our <span className="text-primary">Leaders</span>
              </h1>
              <p className="mb-8 text-lg text-gray-700 max-w-3xl mx-auto">
                Visionary healthcare professionals dedicated to excellence, innovation, and compassionate patient care.
              </p>
            </div>
          </div>
        </section>
 
        {/* <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto">
                Our leadership team brings together decades of experience in healthcare, management, and innovation to guide Pranaam Hospitals towards excellence.
              </p>
            </div>
 
            <Carousel className="w-full max-w-5xl mx-auto">
              <CarouselContent>
                {doctors.length > 0 ? (
                  doctors.map((doctor) => {
                    if (!doctor) return null
                    const name = doctor?.title?.rendered || "No name"
                    const specialty = doctor?.acf?.expertised_area || "Specialty not available"
                    const experience = doctor?.acf?.latest_achievement || doctor?.excerpt?.rendered || ""
                    const image =
                      doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                      doctor.featured_media_url ||
                      "/placeholder.svg?height=300&width=300&text=Doctor"
 
                    return (
                      <CarouselItem key={doctor.id} className="md:basis-1/2 lg:basis-1/3">
                        <DoctorCard
                          name={name}
                          specialty={specialty}
                          experience={experience}
                          image={image}
                          slug={doctor.slug}
                        />
                      </CarouselItem>
                    )
                  })
                ) : (
                  <p className="text-center w-full py-6">Loading doctors...</p>
                )}
              </CarouselContent>
 
              <div className="flex justify-center mt-8">
                <CarouselPrevious className="relative mr-2 left-0" />
                <CarouselNext className="relative ml-2 right-0" />
              </div>
            </Carousel>
          </div>
        </div> */}
        <OurDoctorswidget />;
      </main>
    </>
  )
}